import React, { useEffect, useState } from 'react';
import NavBar from './NavBar';
import styled from 'styled-components';
import { useLocation } from 'react-router';
import * as routes from '../utils/routes';
import SubscriptionBanner from './SubscriptionBanner';
import { useSelector } from 'react-redux';
import { RootState } from '../types';
import { useSubscription } from '../hooks/useSubscription';

const PageWrapper = styled.div<{ $isNavbarVisible: boolean; $isExpired: boolean }>`
	padding-left: ${(props) => (props.$isNavbarVisible ? '250px' : '0px')};
	padding-top: ${(props) => (props.$isExpired && props.$isNavbarVisible ? '60px' : '0px')};
	background-color: ${(props) => (props.$isExpired ? 'white' : '#f3f4f8')};
	@media (max-width: 768px) {
		padding-left: 0;
		padding-top: ${(props) => `${(props.$isNavbarVisible ? 60 : 0) + (props.$isExpired ? 90 : 0)}px`};
	}
`;

const SubscriptionBannerWrapper = styled.div<{ $isNavbarVisible: boolean }>`
	padding: 15px 15px 15px ${(props) => (props.$isNavbarVisible ? '265px' : '0px')};
	position: absolute;
	top: 0;
	left: 0;
	zindex: 1200;
	width: 100%;
	@media (max-width: 768px) {
		padding-left: 15px;
		padding-top: ${(props) => (props.$isNavbarVisible ? '60px' : '0px')};
	}
`;

export default function Navigation(props: any) {
	const location = useLocation();
	const [isNavbarVisible, setIsNavbarVisible] = useState<boolean>(false);
	const user = useSelector((state: RootState) => state.auth.user);
	const { isExpired, isInGracePeriod } = useSubscription();

	useEffect(() => {
		const path = location.pathname;

		if (path === routes.LANDING_PAGE) {
			setIsNavbarVisible(false);
			return;
		}

		const noSidenavRoutes = [
			routes.LOGIN,
			routes.REGISTER,
			routes.FORGOTTEN_PASSWORD,
			routes.RESET_PASSWORD,
			routes.VERIFY_EMAIL,
			routes.SHOP_SELECTOR,
			routes.INVOICE,
		];

		const isNoSidenavRoute = noSidenavRoutes.some((route) => {
			if (route === '/') return true;
			// Check if the path starts with the route
			return path.startsWith(route.replace(/:\w+/g, ''));
		});

		if (isNoSidenavRoute) {
			setIsNavbarVisible(false);
		} else {
			setIsNavbarVisible(true);
		}
	}, [location]);

	return (
		<>
			{isNavbarVisible && <NavBar />}
			{isNavbarVisible && (
				<SubscriptionBannerWrapper $isNavbarVisible={isNavbarVisible}>
					<SubscriptionBanner
						isOwner={!!user?.is_owner}
						isInGracePeriod={isInGracePeriod}
						isExpired={isExpired}
					/>
				</SubscriptionBannerWrapper>
			)}
			<PageWrapper $isNavbarVisible={isNavbarVisible} $isExpired={isExpired || isInGracePeriod}>
				{props.children}
			</PageWrapper>
		</>
	);
}
